// Silent login (`/?td=`) and SSO set localStorage.isSilentLogin: single pages without header / menu / footer, and the
// router logs the user out of list pages. Read it here instead of repeating the localStorage string in each page.
export const isSilentLogin = () => localStorage.getItem("isSilentLogin") === "true";

// The mobile app webview opens pages with ?is_from_mobile=1 (it has its own back navigation).
export const isFromMobile = (route) => route?.query?.is_from_mobile == 1;
